import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "../locales";

Vue.use(VueI18n);

const numberFormats = {
  ru: {
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },

  en: {
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },

  ar: {
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },

  es: {
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },

  fa: {
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },

  kz: {
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },

  pt: {
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },

  fr: {
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
};

const locales = process.env.VUE_APP_LANGS.split(",");
let locale =
  localStorage.getItem("currentLang") || navigator.language.slice(0, 2);
if (!locales.includes(locale)) {
  locale = process.env.VUE_APP_DEFAULT_LANG;
}

const i18n = new VueI18n({
  locales,
  locale,
  messages,
  numberFormats,
  missing: (locale, key, vm) => {
    // Return a default value for missing keys
    if (key.indexOf("Titles.") !== -1) {
      const defaultTitleTail = key.split(".").slice(0, -1);
      return messages[process.env.VUE_APP_INSTALLATION][defaultTitleTail[0]][
        defaultTitleTail[1]
      ].default; // or return a default translation
    }

    return key;
  },
});

export default i18n;
